"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _index = _interopRequireDefault(require("@/components/Store/SalesKPIRecord/index.vue"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/**
 * info:
 * step4 销售记录 page
 * 该页面只读
 */
/** components */
var _default2 = exports.default = {
  components: {
    SalesKPIRecord: _index.default
  },
  props: {
    // 编辑模式 view edit
    mode: {
      type: String,
      default: 'edit'
    },
    // 当前页面用到的 所有下拉options配置
    /**
     * optConfig.ssbtypeOptions: [], // 店招品牌select
     */
    optConfig: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    // 计划任务详情
    ptInfo: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  computed: {
    storeCode: function storeCode() {
      return this.ptInfo.storeCode;
    },
    storePk: function storePk() {
      return this.ptInfo.storePk;
    }
  },
  watch: {
    storeCode: {
      deep: true,
      immediate: true,
      handler: function handler(val, newVal) {
        // console.log(8881111, val, this.ptInfo)
        if (val !== newVal) {
          this.initCharts();
        }
      }
    }
  },
  methods: {
    // 初始化图表
    initCharts: function initCharts() {
      var _this = this;
      this.$nextTick(function () {
        // 有详情才初始化
        if (_this.ptInfo.storeCode) {
          _this.$refs['salesKPIRecord'].initEcharts();
        }
      });
    },
    // 保存草稿
    onSaveDraft: function onSaveDraft() {
      console.log('保存草稿');
      this.$emit('draft');
    },
    // 下一步
    onNext: function onNext() {
      console.log('下一步');
      this.$emit('next');
    }
  }
};